import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class StaffEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      id: this.props.staff_data.staff_id,
      name: this.props.staff_data.name,
      nickname: this.props.staff_data.nickname,
      civil_state: this.props.staff_data.civil_state,
      email: this.props.staff_data.email,
      phone_1: this.props.staff_data.phone_1,
      ddd_1: this.props.staff_data.ddd_1,
      phone_2: this.props.staff_data.phone_2,
      ddd_2: this.props.staff_data.ddd_2,
      address: this.props.staff_data.address,
      number: this.props.staff_data.number,
      complement: this.props.staff_data.complement,
      city: this.props.staff_data.city,
      state: this.props.staff_data.state,
      country: this.props.staff_data.country,
      cep: this.props.staff_data.cep,
      cpf: this.props.staff_data.cpf,
      identity: this.props.staff_data.identity,
      id_uf: this.props.staff_data.id_uf,
      id_date: this.props.staff_data.id_date,
      id_exp: this.props.staff_data.id_exp,
      date_of_birth: this.props.staff_data.date_of_birth,
      neighborhood: this.props.staff_data.neighborhood,
      naturality: this.props.staff_data.naturality,
      scholarly: this.props.staff_data.scholarly,
      mother: this.props.staff_data.mother,
      father: this.props.staff_data.father,
      confidence_us: this.props.staff_data.confidence_us,
      expire_us: this.props.staff_data.expire_us,
      confidence_eu: this.props.staff_data.confidence_eu,
      expire_eu: this.props.staff_data.expire_eu,
      photo: this.props.staff_data.photo,
      ctps: this.props.staff_data.ctps,
      ctps_serial: this.props.staff_data.ctps_serial,
      ctps_expedition: this.props.staff_data.ctps_expedition,
      ctps_uf: this.props.staff_data.ctps_uf,
      pis: this.props.staff_data.pis,
      blood_type: this.props.staff_data.blood_type,
      inscription: this.props.staff_data.inscription,
      sispat: this.props.staff_data.sispat,
      canac: this.props.staff_data.canac,
      license: this.props.staff_data.license,
      hired: this.props.staff_data.hired,
      car_adm: this.props.staff_data.car_adm,
      car_atu: this.props.staff_data.car_atu,
      type: this.props.staff_data.type,
      race: this.props.staff_data.race,
      uf_birth: this.props.staff_data.uf_birth,
      city_birth: this.props.staff_data.city_birth,
      country_birth: this.props.staff_data.country_birth,
      aso: this.props.staff_data.aso_str,
      electrocard: this.props.staff_data.electrocard_str,
      sapiens_code: this.props.staff_data.sapiens_code,
    };

    this.locale = getLocale();

    //bind específico
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined' && typeof newProps.staff_data.name !== 'undefined') {
      this.setState({
        id: newProps.staff_id,
        name: newProps.staff_data.name,
        nickname: newProps.staff_data.nickname,
        civil_state: newProps.staff_data.civil_state,
        email: newProps.staff_data.email,
        ddd_1: newProps.staff_data.ddd_1,
        phone_1: newProps.staff_data.phone_1,
        ddd_2: newProps.staff_data.ddd_2,
        phone_2: newProps.staff_data.phone_2,
        address: newProps.staff_data.address,
        number: newProps.staff_data.number,
        complement: newProps.staff_data.complement,
        city: newProps.staff_data.city,
        state: newProps.staff_data.state,
        country: newProps.staff_data.country,
        cep: newProps.staff_data.cep,
        cpf: newProps.staff_data.cpf,
        identity: newProps.staff_data.identity,
        id_uf: newProps.staff_data.id_uf,
        id_date: newProps.staff_data.id_date_str,
        id_exp: newProps.staff_data.id_exp,
        date_of_birth: newProps.staff_data.date_of_birth_str,
        neighborhood: newProps.staff_data.neighborhood,
        naturality: newProps.staff_data.naturality,
        scholarly: newProps.staff_data.scholarly,
        mother: newProps.staff_data.mother,
        father: newProps.staff_data.father,
        confidence_us: newProps.staff_data.confidence_us,
        expire_us: newProps.staff_data.expire_us_str,
        confidence_eu: newProps.staff_data.confidence_eu,
        expire_eu: newProps.staff_data.expire_eu_str,
        photo: newProps.staff_data.photo,
        ctps: newProps.staff_data.ctps,
        ctps_serial: newProps.staff_data.ctps_serial,
        ctps_expedition: newProps.staff_data.ctps_expedition,
        ctps_uf: newProps.staff_data.ctps_uf,
        pis: newProps.staff_data.pis,
        blood_type: newProps.staff_data.blood_type,
        inscription: newProps.staff_data.inscription,
        sispat: newProps.staff_data.sispat,
        canac: newProps.staff_data.canac,
        license: newProps.staff_data.license,
        hired: newProps.staff_data.hired_str,
        car_adm: newProps.staff_data.car_adm,
        car_atu: newProps.staff_data.car_atu,
        type: newProps.staff_data.type,
        race: newProps.staff_data.race,
        uf_birth: newProps.staff_data.uf_birth,
        city_birth: newProps.staff_data.city_birth,
        country_birth: newProps.staff_data.country_birth,
        aso: newProps.staff_data.aso_str,
        electrocard: newProps.staff_data.electrocard_str,
        sapiens_code: newProps.staff_data.sapiens_code
      });
    }
  }


    // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
        id: this.state.id,
        name: this.state.name,
        nickname: this.state.nickname,
        civil_state: this.state.civil_state,
        email: this.state.email,
        ddd_1: this.state.ddd_1,
        phone_1: this.state.phone_1,
        ddd_2: this.state.ddd_2,
        phone_2: this.state.phone_2,
        address: this.state.address,
        number: this.state.number,
        complement: this.state.complement,
        city: this.state.city,
        state: this.state.state,
        country: this.state.country,
        cep: this.state.cep,
        cpf: this.state.cpf,
        identity: this.state.identity,
        id_uf: this.state.id_uf,
        id_date: this.state.id_date,
        id_exp: this.state.id_exp,
        date_of_birth: this.state.date_of_birth,
        neighborhood: this.state.neighborhood,
        naturality: this.state.naturality,
        scholarly: this.state.scholarly,
        mother: this.state.mother,
        father: this.state.father,
        confidence_us: this.state.confidence_us,
        expire_us: this.state.expire_us,
        confidence_eu: this.state.confidence_eu,
        expire_eu: this.state.expire_eu,
        photo: this.state.photo,
        ctps: this.state.ctps,
        ctps_serial: this.state.ctps_serial,
        ctps_expedition: this.state.ctps_expedition,
        ctps_uf: this.state.ctps_uf,
        pis: this.state.pis,
        blood_type: this.state.blood_type,
        inscription: this.state.inscription,
        sispat: this.state.sispat,
        canac: this.state.canac,
        license: this.state.license,
        hired: this.state.hired,
        car_adm: this.state.car_adm,
        car_atu: this.state.car_atu,
        type: this.state.type,
        race: this.state.race,
        uf_birth: this.state.uf_birth,
        city_birth: this.state.city_birth,
        country_birth: this.state.country_birth,
        aso: this.state.aso,
        electrocard: this.state.electrocard,
        sapiens_code: this.state.sapiens_code
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  // Fetch salvando a edição
  editar(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.edit}>
    <h4>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.tituloInformacoesPessoais}</h4>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Nome}:</label>
        <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Apelido}:</label>
        <input type="text" className="form-control" name="nickname" value={this.state.nickname} onChange={this.handleChange.bind(this, 'nickname')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Telefone1}:</label>
        <div className="row">
          <div className="col-md-3">
            <input type="text" className="form-control" name="ddd_1" value={this.state.ddd_1} onChange={this.handleChange.bind(this, 'ddd_1')} />
          </div>
          <div className="col-md-9">
            <input type="text" className="form-control" name="phone_1" value={this.state.phone_1} onChange={this.handleChange.bind(this, 'phone_1')} />
          </div>
        </div>
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Telefone2}:</label>
        <div className="row">
          <div className="col-md-3">
            <input type="text" className="form-control" name="ddd_2" value={this.state.ddd_2} onChange={this.handleChange.bind(this, 'ddd_2')} />
          </div>
          <div className="col-md-9">
            <input type="text" className="form-control" name="phone_2" value={this.state.phone_2} onChange={this.handleChange.bind(this, 'phone_2')} />
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.EstadoCivil}:</label>
        <input type="text" className="form-control" name="civil_state" value={this.state.civil_state} onChange={this.handleChange.bind(this, 'civil_state')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Email}:</label>
        <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Naturalidade}:</label>
        <input type="text" className="form-control" name="naturality" value={this.state.naturality} onChange={this.handleChange.bind(this, 'naturality')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Escolaridade}:</label>
        <input type="text" className="form-control" name="scholarly" value={this.state.scholarly} onChange={this.handleChange.bind(this, 'scholarly')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.NomeDaMae}:</label>
        <input type="text" className="form-control" name="mother" value={this.state.mother} onChange={this.handleChange.bind(this, 'mother')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.NomeDoPai}:</label>
        <input type="text" className="form-control" name="father" value={this.state.father} onChange={this.handleChange.bind(this, 'father')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Raca}:</label>
        <input type="text" className="form-control" name="race" value={this.state.race} onChange={this.handleChange.bind(this, 'race')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.DataDeNascimento}:</label>
        <InputMask value={this.state.date_of_birth}  maskChar={null} name="date_of_birth" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_of_birth')} placeholder="dd/mm/aaaa" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Foto}:</label>
        <input type="file" name="photo" className="form-control input-photo" placeholder={this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.placeholder.Arquivo} value={this.state.photo} onChange={this.handleChange.bind(this, 'photo')} />
      </div>
    </div>
    <hr/>
    <h4>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.tituloEndereco}</h4>
    <hr/>
    <div className="row">
      <div className="col-md-12 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Endereco}:</label>
        <input type="text" className="form-control" name="address" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Numero}:</label>
        <input type="text" className="form-control" name="number" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Complemento}:</label>
        <input type="text" className="form-control" name="complement" value={this.state.complement} onChange={this.handleChange.bind(this, 'complement')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Bairro}:</label>
        <input type="text" className="form-control" name="neighborhood" value={this.state.neighborhood} onChange={this.handleChange.bind(this, 'neighborhood')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Cidade}:</label>
        <input type="text" className="form-control" name="city" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Estado}:</label>
        <input type="text" className="form-control" name="state" value={this.state.state} onChange={this.handleChange.bind(this, 'state')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Pais}:</label>
        <input type="text" className="form-control" name="country" value={this.state.country} onChange={this.handleChange.bind(this, 'country')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CEP}:</label>
        <input type="text" className="form-control" name="cep" value={this.state.cep} onChange={this.handleChange.bind(this, 'cep')} />
      </div>
    </div>
    <hr/>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CPF}:</label>
        <input type="text" className="form-control" name="cpf" value={this.state.cpf} onChange={this.handleChange.bind(this, 'cpf')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Identidade}:</label>
        <input type="text" className="form-control" name="identity" value={this.state.identity} onChange={this.handleChange.bind(this, 'identity')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.IdentidadeUF}:</label>
        <input type="text" className="form-control" name="id_uf" value={this.state.id_uf} onChange={this.handleChange.bind(this, 'id_uf')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.IdentidadeDataDeExpedicao}:</label>
        <InputMask value={this.state.id_date}  maskChar={null} name="id_date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'id_date')} placeholder="dd/mm/aaaa" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.IdentidadeOrgaoExpeditor}:</label>
        <input type="text" className="form-control" name="id_exp" value={this.state.id_exp} onChange={this.handleChange.bind(this, 'id_exp')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.PIS}:</label>
        <input type="text" className="form-control" name="pis" value={this.state.pis} onChange={this.handleChange.bind(this, 'pis')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CTPS}:</label>
        <input type="text" className="form-control" name="ctps" value={this.state.ctps} onChange={this.handleChange.bind(this, 'ctps')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CTPSNumeroDeSerie}:</label>
        <input type="text" className="form-control" name="ctps_serial" value={this.state.ctps_serial} onChange={this.handleChange.bind(this, 'ctps_serial')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CTPSExpedicao}:</label>
        <InputMask value={this.state.ctps_expedition}  maskChar={null} name="ctps_expedition" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'ctps_expedition')} placeholder="dd/mm/aaaa" />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CTPSUF}:</label>
        <input type="text" className="form-control" name="ctps_uf" value={this.state.ctps_uf} onChange={this.handleChange.bind(this, 'ctps_uf')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.TipoSanguineo}:</label>
        <input type="text" className="form-control" name="blood_type" value={this.state.blood_type} onChange={this.handleChange.bind(this, 'blood_type')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Matricula}:</label>
        <input type="text" className="form-control" name="inscription" value={this.state.inscription} onChange={this.handleChange.bind(this, 'inscription')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.SISPAT}:</label>
        <input type="text" className="form-control" name="sispat" value={this.state.sispat} onChange={this.handleChange.bind(this, 'sispat')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CANAC}:</label>
        <input type="text" className="form-control" name="canac" value={this.state.canac} onChange={this.handleChange.bind(this, 'canac')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Licenca}:</label>
        <input type="text" className="form-control" name="license" value={this.state.license} onChange={this.handleChange.bind(this, 'license')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Contratacao}:</label>
        <InputMask value={this.state.hired}  maskChar={null} name="hired" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'hired')} placeholder="dd/mm/aaaa" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CargoDeAdmissao}:</label>
        <input type="text" className="form-control" name="car_adm" value={this.state.car_adm} onChange={this.handleChange.bind(this, 'car_adm')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CargoAtual}:</label>
        <input type="text" className="form-control" name="car_atu" value={this.state.car_atu} onChange={this.handleChange.bind(this, 'car_atu')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.EstadoDeNascimento}:</label>
        <input type="text" className="form-control" name="uf_birth" value={this.state.uf_birth} onChange={this.handleChange.bind(this, 'uf_birth')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.CidadeDeNascimento}:</label>
        <input type="text" className="form-control" name="city_birth" value={this.state.city_birth} onChange={this.handleChange.bind(this, 'city_birth')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.PaisDeNascimento}:</label>
        <input type="text" className="form-control" name="country_birth" value={this.state.country_birth} onChange={this.handleChange.bind(this, 'country_birth')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.ASO}:</label>
        <InputMask value={this.state.aso} maskChar={null} name="aso" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'aso')} placeholder="dd/mm/aaaa" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.formulario.Eletrocardiograma}:</label>
        <InputMask value={this.state.electrocard} maskChar={null} name="electrocard" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'electrocard')} placeholder="dd/mm/aaaa" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
  </form>
</div>
    );
  }
}

export default StaffEditTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffEditTab.js